import { BasePaginateParamsSchema } from '@/api/common'
import { z } from 'zod'

export const Inv4020SearchParamsSchema = z
  .object({
    location: z.string().optional(),
    itemId: z.coerce.number().optional(),
    lotNo: z.string().optional(),
    mold: z.string().optional(),
    lotDateFrom: z.coerce.date().optional(),
    lotDateTo: z.coerce.date().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type Inv4020SearchParams = z.infer<typeof Inv4020SearchParamsSchema>

export const Inv4020SearchResultModelSchema = z.object({
  id: z.number(),
  location: z.string(),
  itemId: z.number(),
  itemCode: z.string(),
  itemName: z.string(),
  lotNo: z.string(),
  mold: z.string(),
  lotDate: z.coerce.date(),
  isClaimItem: z.boolean(),
  qty: z.number(),
  status: z.number(),
  tagId: z.string().uuid().nullable(),
})

export type Inv4020SearchResultModel = z.infer<
  typeof Inv4020SearchResultModelSchema
>

export const Inv4020SearchResultSchema = z.object({
  totalPage: z.number(),
  pageNumber: z.number(),
  pageSize: z.number(),
  data: z.array(Inv4020SearchResultModelSchema),
})

export type Inv4020SearchResult = z.infer<typeof Inv4020SearchResultSchema>
